// extracted by mini-css-extract-plugin
module.exports = {"Table":"BlockTable_Table__1pasR"};